import React, { FC } from 'react';
import { TrevorIcon, Tooltip, Heading, Subtitle } from '@trevor/ui-components';
import {
  BodyContainer,
  ChatWithUs,
  CopyIcon,
  ErrorDisplayerContainer,
  ErrorIdBanner,
  TitleContainer,
} from './ErrorDisplayer.style';
import { useTimeoutToggle } from '../../../hooks';

const toggleCopyRollbarErrorId = `toggleRollbarCopyErrorId`;

type ErrorPageProps = {
  info: string;
  rollbarErrorId: string;
};
export const ErrorDisplayer: FC<ErrorPageProps> = ({
  info,
  rollbarErrorId,
}) => {
  const [copied, toggleCopied] = useTimeoutToggle(2000);

  const handleCopy = () => {
    window.navigator.clipboard
      .writeText(rollbarErrorId)
      .then(() => {
        toggleCopied();
      })
      .catch(() => window.alert('Oops, unable to copy'));
  };
  return (
    <ErrorDisplayerContainer>
      <TitleContainer>
        <TrevorIcon name="illustration-whoops" size="xl" />
        <Heading variant={1}>Oh no!</Heading>
      </TitleContainer>
      <BodyContainer>
        <Subtitle variant={1}>{info}</Subtitle>
        <Subtitle variant={1}>
          Please refresh page, or
          <br />
          <ChatWithUs>
            Chat with us <TrevorIcon name="annotate" />
          </ChatWithUs>
        </Subtitle>
        <Subtitle variant={2}>
          Use this error handle when contacting support:
        </Subtitle>
      </BodyContainer>
      <ErrorIdBanner data-tooltip-id={toggleCopyRollbarErrorId}>
        {rollbarErrorId}
        <CopyIcon onClick={handleCopy} />
      </ErrorIdBanner>
      <Tooltip
        id={toggleCopyRollbarErrorId}
        variant="success"
        place="right"
        isOpen={copied}
      >
        Copied!
      </Tooltip>
    </ErrorDisplayerContainer>
  );
};
